import { Component, Vue, Prop } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose, faCircleExclamation } from '@fortawesome/free-solid-svg-icons'

import EntryModalOptions from '../types/EntryModalOptions'
import blackListCNPJ from '../constants/blackListCNPJ'
import fetch from '@/helpers/fetch'
import Fuse from 'fuse.js'
import cnjParser from '@/helpers/cnjParser'

library.add(faClose, faCircleExclamation)

@Component({
	components: {
		Loader,
		vSelect,
	},
	mixins: [validationMixin],
})
export default class CreateThermometerEntry extends Vue {
	@Prop({ required: true }) options!: EntryModalOptions

	form = {
		cnj: null as string | null,
		cnpj: null,
		company_name: null as any,
		// company_group_name: null,
		state: null,
		city: null,
		law_firm: null,
		courthouse: null,
		market_sector: null,
		calc_subject: null,
		publicly_traded: null,
		multinational: null,
		distribution_date: null,
		distribution_date_formatted: null as string | null,
		complete_research: null,
		research_date: new Date(),
	}

	localOptions = {
		cnpjs: [] as Array<any>,
		sectors: [] as Array<any>,
		cities: [] as Array<any>,
	}

	submitLoading = false
	loadingCNPJs = false
	loadingCollectionByCNJ = false
	loadingSectors = false

	get minBlockDate() {
		return new Date()
	}

	// se necessario adiciona a empresa na array de opcoes
	addCompany(typedCompany) {
		if (!typedCompany) return
		if (typeof typedCompany === 'string') {
			typedCompany = { company_name: typedCompany }
		}

		const found = this.options.companies.find(
			(company) => company.company_name === typedCompany.company_name,
		)
		if (!found) this.options.companies.push(typedCompany)

		this.loadCNPJs()
		this.loadSectors()
	}

	addCNPJ(typedCNPJ) {
		if (!typedCNPJ) return
		const found = this.localOptions.cnpjs.find((cnpj) => cnpj === typedCNPJ)
		if (!found) {
			if (typedCNPJ.length >= 18) this.localOptions.cnpjs.push(typedCNPJ)
		}
	}

	addCity(typedCity) {
		if (!typedCity) return
		const found = this.localOptions.cities.find(
			(city) => city === typedCity,
		)
		if (!found) this.localOptions.cities.push(typedCity)
	}

	addCompanyGroup(typedCompanyGroup) {
		if (!typedCompanyGroup) return
		const found = this.options.companiesGroups.find(
			(company) => company === typedCompanyGroup,
		)
		if (!found) this.options.companiesGroups.push(typedCompanyGroup)
	}

	comboBoxSearch(options, search) {
		if (search.length === 0) return options

		const fuse = new Fuse(options, {
			keys: ['company_name'],
			shouldSort: true,
			ignoreLocation: true,
			threshold: 0,
		})

		const filteredOptions = fuse.search(search).map(({ item }) => item)

		if (filteredOptions.length === 0) filteredOptions.push(search)

		return filteredOptions
	}

	fuseSearch(options, search) {
		if (search.length === 0) return options

		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
			threshold: 0.3,
		})

		return fuse.search(search).map(({ item }) => item)
	}

	@Validations()
	validations() {
		return {
			form: {
				cnj: {
					required,
					minLength: minLength(25),
					validaCNJ,
				},
				cnpj: {
					required,
					minLength: minLength(18),
					blockCNPJ: this.blockCNPJ,
				},
				company_name: {
					required,
				},
				calc_subject: {
					required,
				},
				state: {
					required,
				},
				city: {
					required,
				},
				law_firm: {
					required,
				},
				courthouse: {
					required,
				},
				market_sector: {
					required,
				},
				distribution_date: {
					required,
				},
				research_date: {
					required,
				},
			},
		}
	}

	vSelectStateClass(state) {
		return state === null ? '' : state ? 'vs-is-valid' : 'vs-is-invalid'
	}

	validateState(name) {
		// @ts-ignore
		const { $dirty, $error } = this.$v.form[name]
		return $dirty ? !$error : null
	}

	clearField(fieldname) {
		this.form[fieldname] = null
	}

	clearForm() {
		this.form.cnj = null
		this.form.cnpj = null
		this.form.company_name = null
		// this.form.company_group_name = null
		this.form.state = null
		this.form.city = null
		this.form.law_firm = null
		this.form.courthouse = null
		this.form.market_sector = null
		this.form.calc_subject = null
		this.form.publicly_traded = null
		this.form.multinational = null
		this.form.distribution_date = null
		this.form.distribution_date_formatted = null
		this.form.complete_research = null
		this.form.research_date = new Date()

		this.$nextTick(() => {
			this.$v.$reset()
		})
	}

	clearTrialData() {
		this.form.cnj = null
		this.form.state = null
		this.form.city = null
		this.form.law_firm = null
		this.form.courthouse = null
		this.form.calc_subject = null
		this.form.distribution_date = null
		this.form.distribution_date_formatted = null
		this.resetCalcSubjects()
	}

	hidden() {
		this.clearForm()
		this.resetCalcSubjects()
		this.$emit('hidden')
	}

	resetCalcSubjects() {
		this.options.calcSubjects.sort((a, b) => a.id - b.id)

		this.options.calcSubjects.forEach(
			(subject) => (subject.disabled = false),
		)
	}

	async loadCollectionByCNJ() {
		this.resetCalcSubjects()

		this.loadingCollectionByCNJ = true
		const res = await fetch.get(
			'/api/thermometer/collections/by/cnj?cnj=' +
				encodeURIComponent(this.form.cnj!.replace(/[.-]/g, '')),
		)

		if (res.data.length > 0) {
			for (let n = 0; n < res.data.length; n++) {
				const entry = res.data[n]
				const index = this.options.calcSubjects.findIndex(
					(subject) => subject.id === entry.calc_subject.id,
				)
				if (index < 0) continue

				const subject = this.options.calcSubjects.splice(index, 1)[0]
				subject.disabled = true
				this.options.calcSubjects.unshift(subject)
			}
		}

		this.loadingCollectionByCNJ = false
	}

	async parseCNJ() {
		if (!validaCNJ(this.form.cnj)) return

		const data = await cnjParser.getData(this.form.cnj)

		if (!data) return

		this.form.state = data[0].state
		const foundCourthouse = this.options.courthouses.find(
			(courthouse) =>
				courthouse.name === data[0].courthouse.toUpperCase(),
		)
		if (foundCourthouse) this.form.courthouse = foundCourthouse.id
		this.form.city = data[0].city
		// @ts-ignore
		this.localOptions.cities = data.map((elem) => {
			return elem.city
		})

		await this.loadCollectionByCNJ()
	}

	onCalendarContext(ctx) {
		if (ctx.selectedYMD) {
			this.form.distribution_date_formatted = ctx.selectedFormatted
		}
	}

	checkFormattedDistributionDate() {
		if (!this.form.distribution_date_formatted) {
			this.$v.form.distribution_date!.$touch()
			return
		}

		const dateString = this.form.distribution_date_formatted.replace(
			/(\d{2})\/(\d{2})\/(\d{4})/,
			'$3-$2-$1',
		)

		if (
			this.form.distribution_date_formatted === dateString ||
			new Date(dateString).getTime() <= 0
		) {
			this.$v.form.distribution_date!.$model = null
			this.form.distribution_date_formatted = null
		} else {
			this.$v.form.distribution_date!.$model = dateString
		}

		this.$v.form.distribution_date!.$touch()
	}

	blockCNPJ(formattedCNPJ) {
		// @ts-ignore
		const cnpj = formattedCNPJ ? formattedCNPJ.replace(/[.\-/]/g, '') : ''
		const found = blackListCNPJ.find((blocked) => blocked.cnpj === cnpj)

		if (found) {
			const h = this.$createElement
			const vNodesMsg = h('p', { class: ['m-0'] }, [
				'CNPJ: ' + formattedCNPJ,
				h('br'),
				'Empresa: ' + found.company,
				h('br'),
				found.reason,
			])

			this.$bvToast.toast([vNodesMsg], {
				title: 'CNPJ Bloqueado!',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})

			this.form.cnpj = null
			return false
		}

		return true
	}

	async loadCNPJs() {
		if (this.form.company_name === null) return

		// eslint-disable-next-line camelcase
		const name: any = this.form.company_name?.company_name

		this.localOptions.cnpjs = []
		const res = await fetch.get(
			'/api/thermometer/collections/distinct/cnpjs?company_name=' +
				encodeURIComponent(name),
		)

		this.localOptions.cnpjs.push(
			...res.data.map((cnpj) => {
				return cnpj.replace(
					/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
					'$1.$2.$3/$4-$5',
				)
			}),
		)
		this.loadingCNPJs = false

		if (this.localOptions.cnpjs.length) {
			this.form.cnpj = this.localOptions.cnpjs[0]
		}
	}

	async loadSectors() {
		if (this.form.company_name === null) return
		const name = this.form.company_name.company_name

		this.loadingSectors = true
		this.localOptions.sectors = []
		const res = await fetch.get(
			'/api/thermometer/collections/distinct/market-sectors?company_name=' +
				encodeURIComponent(name),
		)

		this.localOptions.sectors.push(...res.data)
		this.loadingSectors = false

		if (this.localOptions.sectors.length) {
			this.form.market_sector = this.localOptions.sectors[0]
		}
	}

	async submit() {
		this.$v.form.$touch()
		if (this.$v.form.$anyError) {
			return
		}

		this.submitLoading = true
		const body = Object.assign({}, this.form, {
			// @ts-ignore
			cnj: this.form.cnj ? this.form.cnj.replace(/[.-]/g, '') : '',
			// @ts-ignore
			cnpj: this.form.cnpj ? this.form.cnpj.replace(/[.\-/]/g, '') : '',
		})
		delete body.distribution_date_formatted
		const res = await fetch.post('/api/thermometer/entry', body)
		this.submitLoading = false

		if (res.ok) {
			this.$bvToast.toast('Pesquisa Registrada!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			this.clearTrialData()
		} else {
			const h = this.$createElement
			const vNodesMsg = h('p', { class: ['m-0'] }, [
				'Tivemos um erro',
				h('br'),
				res.msg,
			])

			this.$bvToast.toast([vNodesMsg], {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		}
	}
}

function validaCNJ(number) {
	if (!number) return false
	const numero = number.replace(/\./g, '').replace('-', '')

	if (numero.length !== 20) {
		return false
	}

	const bcmod = (x, y) => {
		const take = 5
		let mod: string | number = ''

		do {
			const a = parseInt(mod + x.substr(0, take))
			x = x.substr(take)
			mod = a % y
		} while (x.length)

		return mod
	}

	const numeroProcesso = numero.replace(/[.-]/g, '')

	if (numeroProcesso.length < 14 || isNaN(numeroProcesso)) {
		return false
	}

	const digitoVerificadorExtraido = parseInt(numeroProcesso.substr(-13, 2))

	const vara = numeroProcesso.substr(-4, 4)
	const tribunal = numeroProcesso.substr(-6, 2)
	const ramo = numeroProcesso.substr(-7, 1)
	const anoInicio = numeroProcesso.substr(-11, 4)
	const tamanho = numeroProcesso.length - 13
	const numeroSequencial = numeroProcesso.substr(0, tamanho).padStart(7, '0')

	const digitoVerificadorCalculado =
		98 -
		bcmod(
			numeroSequencial + anoInicio + ramo + tribunal + vara + '00',
			'97',
		)

	return digitoVerificadorExtraido === digitoVerificadorCalculado
}
